"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledSoundButton = styled_components_1.default.svg `
  cursor: pointer;
  transition: filter 0.2s ease-in-out;

  &:hover {
    filter: brightness(0.7);
  }
`;
const SoundButton = (props) => (react_1.default.createElement(StyledSoundButton, Object.assign({ className: "sound-icon", width: "24", height: "24", viewBox: "0 0 24 24", fill: "transparent", strokeWidth: "2", xmlns: "http://www.w3.org/2000/svg" }, props),
    react_1.default.createElement("g", { clipPath: "url(#clip0_2638_11128)" },
        react_1.default.createElement("path", { d: "M4 8.5H5.18975C6.4764 8.5 7.72233 8.04891 8.71076 7.22522L11.6799 4.75093C12.0056 4.47955 12.5 4.71112 12.5 5.13504V18.865C12.5 19.2889 12.0056 19.5205 11.6799 19.2491L8.71076 16.7748C7.72233 15.9511 6.4764 15.5 5.18975 15.5H4C3.17157 15.5 2.5 14.8284 2.5 14V10C2.5 9.17157 3.17157 8.5 4 8.5Z", stroke: "#6E76FB" }),
        react_1.default.createElement("path", { d: "M15.5352 15.5359C17.4878 13.5833 17.4878 10.4175 15.5352 8.46484", stroke: "#6E76FB", strokeLinecap: "round" }),
        react_1.default.createElement("path", { d: "M18.5352 17.4641C21.5531 14.4462 21.5531 9.55311 18.5352 6.53516", stroke: "#6E76FB", strokeLinecap: "round" })),
    react_1.default.createElement("defs", null,
        react_1.default.createElement("clipPath", { id: "clip0_2638_11128" },
            react_1.default.createElement("rect", { width: "24", height: "24", fill: "transparent" })))));
exports.default = SoundButton;
